import { useState, useEffect } from 'react'
import blindMatrix from '../utils/blindnessMatrix'
import { Link } from 'react-router-dom'
import '../styles/ColorPicker.css'

const ColorPicker = ({color, setColor, setSimulatedColor, blindType, setBlindType}) => {
  const [matrixId, setMatrixId] = useState("0")
  const hexToRGB = (hex) => {
    hex = hex.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    if (r === 0) {
      return ["00", g, b]
    }
    if (g === 0) {
      return [r, "00", b]
    }
    if (b === 0) {
      return [r, g, "00"]
    }
    return [r, g, b];
  }

  const simulateColorBlindness = ([r, g, b], matrix) => {
    r = Number(r)
    g = Number(g)
    b = Number(b)
    return [
        r * matrix[0][0] + g * matrix[0][1] + b * matrix[0][2],
        r * matrix[1][0] + g * matrix[1][1] + b * matrix[1][2],
        r * matrix[2][0] + g * matrix[2][1] + b * matrix[2][2]
    ];
  }

  const handleMatrixId = (e) => {
    const selectIndex = e.target.selectedIndex
    const selectOption = e.target.options[selectIndex]
    const selectedId = selectOption.id
    setMatrixId(selectedId)
  }
 
  useEffect(() => {
    const hexColor = hexToRGB(color)
    const arrMatrix = blindMatrix[matrixId]
    const simulColor = simulateColorBlindness(hexColor, arrMatrix)
    setSimulatedColor(simulColor)
  }, [color, matrixId, setSimulatedColor])

  return (
    <div className='color-picker-page'>
        <section className='pick-color'>
          <div className='color-input-group'>
            <label htmlFor="color-picker">Pick a color:</label>
            <input 
                type="color" 
                name="color-picker" 
                id="color-picker" 
                className='color-picker'
                value={color}
                onChange={(e) => setColor(e.target.value)}
            />
          </div>
          <div className='show-color' 
               style={{backgroundColor: `${color}`}}
          ></div>
        </section>
        <section className='color-settings'>
          <select 
              name="pick-color-blind" 
              id={matrixId} 
              value={blindType}
              onChange={(e) => {
                handleMatrixId(e)
                setBlindType(e.target.value)
              }}>
              <option value="PROTANOPIA" id='0'>Protanopia - Red Cone Deficiency</option>
              <option value="DEUTERANOPIA" id='1'>Deuteranopia - Green Cone Deficiency</option>
              <option value="TRITANOPIA" id='2'>Tritanopia - Blue Cone Deficiency</option>
              <option value="ACHROMATOPSIA" id='3'>Achromatopsia - Grayscale</option>
              <option value="PROTANOMALY" id='4'>Protanomaly - Weak Red Cone</option>
              <option value="DEUTERANOMALY" id='5'>Deuteranomaly - Weak Green Cone</option>
              <option value="TRITANOMALY" id='6'>Tritanomaly - Weak Blue/Yellow Cone</option>
              <option value="MONOCHROMACY" id='7'>Monochromacy - Only Blue Functional</option>
          </select>
          <Link to="/simulated-page">
              <button>Simulate Color Blindness</button>
          </Link>
        </section>
    </div>
  )
}

export default ColorPicker